module.exports = __webpack_public_path__ + "static/media/1POLICY43.f402ef2c.jpg";